'use strict';

angular.module('imagetrend.components')
    .directive('hlpCheckbox', ['Format', function (Format) {
        return {
            restrict: 'AE',
            scope: {
                ngModel: '=',
                question: '=?',

                //attributes
                name: '@?',
                id: '@?',
                classes: '@?',
                checkboxLabel: '@?',
                value: '=?',
                changeFunction: '&?',
                index: '=?',
                showColon: '=?',
                hideLabel: '@?',

                //required
                isRequired: '=?',
                requiredText: '@?',

                //disabled
                isDisabled: '=?',

                //label
                showLabel: '@?',
                label: '@?',
                title: '@?',

                //bridge ** only use when multiple checkboxes directive can't be used.
                array: '=?',
                checkboxItem: '=?',

                //instructions
                instructions: '@?',
                pdf: '=?'
            },
            transclude: true,
            replace: true,
            require: 'ngModel',
            templateUrl: 'templates/checkbox/checkbox.html',
            link: function (scope, elem, attrs, ctrl) {

                //attributes
                if (!attrs.name) { attrs.name = 'checkbox'; }
                if (!attrs.id) { attrs.id = attrs.name; }
                if (attrs.hideLabel === undefined || attrs.hideLabel === null) { attrs.hideLabel = false }

                //label
                var wasEmpty = attrs.label == 'EMPTY';
                if (!attrs.label) { attrs.label = Format.label(attrs.name); } else { if (attrs.label == 'EMPTY') { attrs.label = ''; } }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0 || wasEmpty; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.title) { attrs.title = attrs.label; }

                //required
                //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }
                if (!attrs.requiredText) { attrs.requiredText = 'Please enter a ' + Format.label((scope.label || scope.name)) }

                if (!attrs.index) { attrs.index = 0 }

                if (scope.checkboxItem != null && typeof scope.checkboxItem != 'object') {
                    scope.checkboxItem = { id: scope.checkboxItem, name: scope.checkboxItem };
                }

                scope.$watch('checkboxItem + array', function () {
                    if (scope.checkboxItem != null && scope.array != null) {
                        scope.ngModel = contains(scope.array, scope.checkboxItem.id);
                    }
                });

                scope.updateArray = function (array, item, checked) {
                    var wasString = false;

                    if (angular.isString(array)) {
                        if (array == '') {
                            array = [];
                        }
                        else {
                            array = array.split(',');
                        }
                        wasString = true;
                    }
                    if (item != null) {
                        if (checked) {
                            array = angular.isArray(array) ? array : [];
                            if (!contains(array, item.id)) {
                                if (wasString) {
                                    array.push(item.id);
                                }
                                else {
                                    array.push(item);
                                }
                            }
                        }
                        else {
                            if (angular.isArray(array)) {
                                for (var i = array.length; i--;) {
                                    if (array[i].id == item.id || array[i] == item.id) {
                                        array.splice(i, 1);
                                        break;
                                    }
                                }
                            }
                        }
                    }

                    return wasString ? array.toString() : array;
                }

                // contains
                var contains = function (arr, item) {
                    if (angular.isString(arr)) {
                        arr = arr.split(',');
                    }
                    if (angular.isArray(arr)) {
                        for (var i = arr.length; i--;) {
                            if (arr[i] != null) {
                                if (arr[i].id == item || (angular.isString(arr[i]) && arr[i].toLowerCase() == item.toLowerCase())) {
                                    return true;
                                }
                            }
                        }
                    }
                    return false;
                }

                scope.onChange = function (item) {
                    scope.submitted = false;
                    ctrl.$setViewValue(item);
                    if (angular.isFunction(scope.changeFunction)) {
                        scope.changeFunction();
                    }
                }
                //ctrl.$viewChangeListeners.push(function () {
                //    scope.$eval(attrs.ngChange);
                //});

                scope.submitted = false;
                scope.$on('form:submit', function () {
                    scope.submitted = true;
                });

                scope.$on('$destroy', function () {
                    if (elem) {
                        angular.element(elem).remove();
                        elem = null;
                    }
                });
            }
        };
    }])
;